import type {ExtractPropsWithoutRef} from '@/types';

import styled from '@emotion/styled';
import Views from 'react-swipeable-views';
import {virtualize} from 'react-swipeable-views-utils';

const SwipeableViews = virtualize(Views);

const StyledSliderSwipeableViews = styled(SwipeableViews)`
  margin: 0 -4px;
`;

export const VirtualizedSwipeableViews = styled(
  ({
    className,
    ...restProps
  }: ExtractPropsWithoutRef<typeof StyledSliderSwipeableViews> & {
    className?: string;
  }) => <StyledSliderSwipeableViews slideClassName={className} {...restProps} />
)`
  box-sizing: border-box;
  padding: 0 4px;
`;
